import Swiper from 'swiper/swiper-bundle';

class WbPartnerList {
  constructor() {
    this.init();
  }

  init() {
    this.initSliders();
  }

  initSliders() {
    document.querySelectorAll('.wb-partner-list__slider')?.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: '.wb-partner-list__slider-pagination',
          bulletElement: 'button',
          bulletClass: 'wb-partner-list__slider-pagination__el',
          bulletActiveClass: 'wb-partner-list__slider-pagination__el--active',
          clickable: true,
        },
        breakpoints: {
          768: {
            spaceBetween: 30,
            slidesPerView: 3,
            slidesPerGroup: 2,
          },
          1200: {
            spaceBetween: 30,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          2000: {
            spaceBetween: 40,
            slidesPerView: 5,
            slidesPerGroup: 5,
          },
        },
      });
    });
  }
}

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    window.WbPartnerList = new WbPartnerList();
  }
});
